import React, { FC, useState } from "react";

import axios from "axios";

import ShareMenu from "Components/ShareMenu";

interface Props {
  className?: string;
  url?: string;
  svgColor?: string;
  backgroundColor?: string;
}
const ShareMenuContainer: FC<Props> = (props: Props) => {
  const { url, className, svgColor, backgroundColor } = props;

  const [tinyURL, setTinyURL] = useState("");
  const [id, setId] = useState(0);

  // this logic is used from aria-viewer
  const generateID = () => {
    let requestId = 0;
    do {
      requestId = Math.round(Math.random() * 1e16);
    } while (requestId < 1e15);
    return requestId;
  };

  const copyURL = () => {
    const requestId = generateID();
    axios({
      method: "post",
      url: `${
        process.env.REACT_APP_API_BASE_URL
      }main/Home/generateTinyURL?t=${Date.now()}`,
      data: `url=${encodeURIComponent(url)}&requestid=${requestId}`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    }).then(
      (response) => {
        setTinyURL(response.data.data.url);
        setId(requestId);
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      (error) => {
        setTinyURL(null);
        setId(requestId);
      }
    );
  };

  return (
    <ShareMenu
      className={className}
      url={url}
      svgColor={svgColor}
      backgroundColor={backgroundColor}
      copyURL={copyURL}
      tinyURL={tinyURL}
      id={id}
    />
  );
};

ShareMenuContainer.defaultProps = {
  url: undefined,
  svgColor: undefined,
  className: undefined,
  backgroundColor: undefined,
};
export default ShareMenuContainer;
try {
    // @ts-ignore
    ShareMenu.displayName = "ShareMenu";
    // @ts-ignore
    ShareMenu.__docgenInfo = { "description": "", "displayName": "ShareMenu", "props": { "className": { "defaultValue": { value: "undefined" }, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "url": { "defaultValue": { value: "undefined" }, "description": "", "name": "url", "required": false, "type": { "name": "string" } }, "svgColor": { "defaultValue": { value: "undefined" }, "description": "", "name": "svgColor", "required": false, "type": { "name": "string" } }, "backgroundColor": { "defaultValue": { value: "undefined" }, "description": "", "name": "backgroundColor", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/ShareMenu/ShareMenu.tsx#ShareMenu"] = { docgenInfo: ShareMenu.__docgenInfo, name: "ShareMenu", path: "src/shared/containers/ShareMenu/ShareMenu.tsx#ShareMenu" };
}
catch (__react_docgen_typescript_loader_error) { }